module.exports = __webpack_public_path__ + "static/tr-section-4@2x-9549b074b148f45948aad41f3187f749.png";